import * as React from 'react';
import Icons from "../../Icons";
import ReactTooltip from "react-tooltip";
import {badQualityMsg} from "../UploadUtils";

interface ThumbnailDoneIconProps {
  originalFileInfos: any,
  identifier: string
}

export const ThumbnailDoneIcon = (props: ThumbnailDoneIconProps) => {

  let colorQualityIcon = "white";
  let bgColorQualityIcon = "green";
  if(props.originalFileInfos && props.originalFileInfos.quality && props.originalFileInfos.quality.quality !== "good") {
    colorQualityIcon = props.originalFileInfos.quality.quality === 'bad' ? 'red' : 'orange';
    bgColorQualityIcon = 'white';
  }

  const renderQualityMsg = () => {
    return (
      <div id="page-qualite" className={''}>
        {props.originalFileInfos.quality.quality === 'good' &&
          <>
            <div className={'bold'}>Qualité optimale</div>
            <p>
              <strong>La qualité de votre image envoyée semble optimale.</strong>
            </p>
          </>
        }
        {props.originalFileInfos.quality.quality == 'middle' &&
          <>
            <div className={'bold'}><Icons icon="warning" size={20} className={'orange'} />  Qualité moyenne</div>
            <p>
              La qualité de votre image est inférieure à nos recommandations. <br/><strong>Votre image peut être légèrement pixelisée.</strong></p>
          </>
        }
        {props.originalFileInfos.quality.quality == 'bad' &&
          <>
            <div className={'bold'}><Icons icon="warning" size={20} className={'red'} />   Qualité mauvaise</div>
            <p>
              {badQualityMsg()}
            </p>
          </>
        }
      </div>
    );
  }

  return (
    <>
      {props.originalFileInfos && props.originalFileInfos.quality && props.originalFileInfos.quality.quality === "bad" &&
        <div className={`position-absolute`} style={{ bottom: '18px', left: '8px' }}>
          <a data-tip='' data-for={props.identifier+'quality'} style={{backgroundColor: `${bgColorQualityIcon}`}} className={`batAutoBtnEditor mb-2 shadow border-0 batAutoBtnEditorJustHover`}>
            <Icons icon={`${props.originalFileInfos.quality.quality === 'good' ? 'done' : 'warning'}`} size={20} className={colorQualityIcon} />
          </a>
          <ReactTooltip   type="dark"  id={props.identifier+'quality'}   className="react-tooltip-clickable-link" place="right"  getContent={() => renderQualityMsg()}  />
        </div>
      }
    </>
  );
}